import { render, staticRenderFns } from "./RequestsList.vue?vue&type=template&id=02d970ca&scoped=true"
import script from "./RequestsList.vue?vue&type=script&lang=js"
export * from "./RequestsList.vue?vue&type=script&lang=js"
import style0 from "./RequestsList.vue?vue&type=style&index=0&id=02d970ca&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d970ca",
  null
  
)

export default component.exports